import { useEffect, useMemo, useState } from "react";

export const useMedia = (query: string) => {
  const mql = useMemo(() => window.matchMedia(query), [query]);
  const [matches, setMatches] = useState(mql.matches);

  useEffect(() => {
    setMatches(mql.matches);

    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);

    // MediaQueryList does not inherit EventTarget in Safari 13
    if ("addEventListener" in mql) {
      mql.addEventListener("change", listener);
      return () => mql.removeEventListener("change", listener);
    } else {
      (mql as MediaQueryList).addListener(listener);
      return () => (mql as MediaQueryList).removeListener(listener);
    }
  }, [mql]);

  return matches;
};
